export function push (errors = [], error) {
  return errors.concat(error)
}
